import axios from './axios'

export const createProjectTargetCost = ({ data }) => axios.post('project_target_costs', data)
export const deleteProjectTargetCost = ({ id }) => axios.delete(`project_target_costs/${id}`)
export const findProjectTargetCost = ({ id, params }) => axios.get(`project_target_costs/${id}`, { params })
export const getProjectTargetCosts = ({ params } = {}) => axios.get('project_target_costs', { params })
export const updateProjectTargetCost = ({ id, data }) => axios.put(`project_target_costs/${id}`, data)
